module.exports = __webpack_public_path__ + "img/Planet_C_Logo.a0c13de5.png";